<template>
  <div>
    <px-view-header title="Minha conta"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && user">
      <px-minha-conta-tabs class="mt-3"
                          :user="user"
                          :loading="loading"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import MinhaContaTabs from './MinhaContaTabs.vue';

export default {
  data() {
    return {
      breadcrumbs: [
        { text: 'Minha conta' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['user', 'loading']),
  },
  components: { pxMinhaContaTabs: MinhaContaTabs },
};
</script>
